import React from "react";
import newsletterImg from "../Assest/images/user-img.jpg"; // image path

const Newsletter = () => {
  return (
    <div className="page">
      {/* PAGE TITLE */}
      <h4 className="mb-4">Newsletter</h4>

      

          <div className="newsletter-card">
            
            {/* LEFT IMAGE */}
            <div className="newsletter-image">
              <img src={newsletterImg} alt="Newsletter" />
            </div>

            {/* RIGHT CONTENT */}
            <div className="newsletter-content">
              <h2>Subscribe to our Newsletter</h2>
              <p>
                Get notified about <span>exclusive offers</span> every week!
              </p>

              <input
                type="email"
                placeholder="your@email.com"
                className="newsletter-input"
              />

              <label className="newsletter-checkbox">
                <input type="checkbox" />
                <span>I would like to receive News & Special Offers</span>
              </label>

              <button className="newsletter-btn">
                Subscribe to Newsletter
              </button>
            </div>

    
        </div>
      </div>
 
  );
};

export default Newsletter;